import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, getTestId, Divider, useBreakpoint, Collapsible, LILAC_400 } from '@airtel/air-design-system';
import { useState, useRef, useEffect } from 'react';
import { View } from 'react-native';
import { StatusCardImageSection } from '../status-card-image-section/StatusCardImageSection';
import { StatusCardSvgSection } from '../status-card-svg-section/StatusCardSvgSection';
import { getSuccessPageStyles } from './SuccessPageStyles';
export var SuccessPage = props => {
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var collapsibleRef = useRef(null);
  var _useState = useState(false),
    isCollapsibleOpen = _useState[0],
    setIsCollapsibleOpen = _useState[1];
  var _useState2 = useState([]),
    collapsedArray = _useState2[0],
    setCollapsedArray = _useState2[1];
  var _useState3 = useState([]),
    unCollapsedArray = _useState3[0],
    setUnCollapsedArray = _useState3[1];
  var successPageStyles = getSuccessPageStyles(isLargeScreen);
  var _props$collapsedState = props.collapsedState,
    _props$collapsedState2 = _props$collapsedState.isCollapsible,
    isCollapsible = _props$collapsedState2 === void 0 ? false : _props$collapsedState2,
    infoArrayCollapsibleLimit = _props$collapsedState.infoArrayCollapsibleLimit,
    _props$collapsedState3 = _props$collapsedState.collapsedCtaText,
    collapsedCtaText = _props$collapsedState3 === void 0 ? 'View More' : _props$collapsedState3,
    _props$collapsedState4 = _props$collapsedState.expandedCtaText,
    expandedCtaText = _props$collapsedState4 === void 0 ? 'View Less' : _props$collapsedState4,
    _props$collapsedState5 = _props$collapsedState.collapsedCtaIcon,
    collapsedCtaIcon = _props$collapsedState5 === void 0 ? 'DownChevronIcon' : _props$collapsedState5,
    _props$collapsedState6 = _props$collapsedState.expandedCtaIcon,
    expandedCtaIcon = _props$collapsedState6 === void 0 ? 'UpChevronIcon' : _props$collapsedState6,
    _props$statusCardProp = props.statusCardProps,
    imageProps = _props$statusCardProp.imageProps,
    title = _props$statusCardProp.title,
    subtitle = _props$statusCardProp.subtitle,
    description = _props$statusCardProp.description,
    _props$infoSectionPro = props.infoSectionProps,
    infoTitle = _props$infoSectionPro.infoTitle,
    infoSubtitle = _props$infoSectionPro.infoSubtitle,
    infoArray = _props$infoSectionPro.infoArray,
    infoNavigationArray = _props$infoSectionPro.infoNavigationArray,
    buttonProps = _props$infoSectionPro.buttonProps,
    onUserAction = props.onUserAction,
    id = props.id,
    theme = props.theme,
    _props$type = props.type,
    type = _props$type === void 0 ? 'svg' : _props$type,
    _props$svg = props.svg,
    svg = _props$svg === void 0 ? {} : _props$svg;
  useEffect(() => {
    if (isCollapsible) {
      if (infoArray.length > infoArrayCollapsibleLimit) {
        var firstArray = infoArray.slice(0, infoArrayCollapsibleLimit);
        var secondArray = infoArray.slice(infoArrayCollapsibleLimit);
        setUnCollapsedArray(firstArray);
        setCollapsedArray(secondArray);
      } else {
        setUnCollapsedArray(infoArray);
      }
    } else {
      setUnCollapsedArray(infoArray);
    }
  }, [infoArray.length]);
  var onTogglePress = () => {
    var _a;
    (_a = collapsibleRef === null || collapsibleRef === void 0 ? void 0 : collapsibleRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    setIsCollapsibleOpen(!isCollapsibleOpen);
  };
  return _jsxs(View, {
    children: [_jsxs(View, Object.assign({
      style: isLargeScreen ? successPageStyles.container : successPageStyles.mobileContainer
    }, {
      children: [_jsxs(View, Object.assign({
        style: successPageStyles.statusCard
      }, {
        children: [_jsxs(View, Object.assign({
          style: successPageStyles.marginBottom
        }, {
          children: [type === 'image' && _jsx(StatusCardImageSection, Object.assign({}, imageProps)), type === 'svg' && _jsx(StatusCardSvgSection, Object.assign({}, svg))]
        })), _jsxs(View, Object.assign({
          style: successPageStyles.statusCardTitle
        }, {
          children: [!!title && _jsx(Typography, Object.assign({
            text: title,
            type: isLargeScreen ? 'body-single-line-xl-bold' : 'body-para-lg-bold',
            theme: theme,
            style: successPageStyles.title
          }, getTestId(title, 'acknowledgementsuccesspage'))), !!subtitle && _jsx(View, Object.assign({
            style: successPageStyles.subtitle
          }, {
            children: _jsx(Typography, Object.assign({
              multiText: subtitle,
              type: 'body-para-sm',
              theme: theme
            }, getTestId('subtitle', 'acknowledgementsuccesspage')))
          })), !!description && _jsx(Typography, Object.assign({
            text: description,
            type: isLargeScreen ? 'body-para-md' : 'body-para-sm',
            theme: theme,
            style: successPageStyles.description
          }, getTestId(description, 'acknowledgementsuccesspage')))]
        }))]
      })), _jsx(View, Object.assign({
        style: successPageStyles.dividersection
      }, {
        children: _jsx(Divider, {
          color: LILAC_400,
          height: 1
        })
      })), _jsxs(View, Object.assign({
        style: successPageStyles.detailsSection
      }, {
        children: [_jsxs(View, {
          children: [!!infoTitle && _jsx(Typography, Object.assign({
            text: infoTitle,
            type: isLargeScreen ? 'body-para-xl-bold' : 'body-para-lg-bold',
            theme: theme
          }, getTestId(infoTitle, 'acknowledgementsuccesspage'))), !!infoSubtitle && _jsx(Typography, Object.assign({
            text: infoSubtitle,
            type: isLargeScreen ? 'body-para-md' : 'body-para-sm',
            theme: theme,
            style: successPageStyles.infoSubtitle
          }, getTestId(infoSubtitle, 'acknowledgementsuccesspage'))), !!infoArray.length && _jsxs(View, Object.assign({
            style: successPageStyles.infoSection
          }, getTestId('collapsedArray', 'acknowledgementsuccesspage'), {
            children: [unCollapsedArray.map(info => {
              return _jsxs(View, Object.assign({
                style: successPageStyles.infoSectionDetail
              }, {
                children: [_jsx(Typography, {
                  text: info.infoKey,
                  type: isLargeScreen ? 'body-single-line-sm' : 'body-single-line-xs',
                  theme: theme,
                  style: successPageStyles.infoSectionKey
                }), _jsxs(View, Object.assign({
                  style: successPageStyles.infoLink
                }, {
                  children: [_jsx(Typography, {
                    text: info.infoValue,
                    type: isLargeScreen ? 'body-para-md-bold' : 'body-para-sm-bold',
                    theme: theme,
                    style: successPageStyles.infoSectionValue
                  }), !!info.hyperLink && _jsx(Button, {
                    buttonType: "tertiary",
                    size: 'md',
                    title: info.hyperLink.title,
                    onPress: () => {
                      (info === null || info === void 0 ? void 0 : info.hyperLink.onPressHyperLink) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                        id
                      }, info.hyperLink.onPressHyperLink), {
                        info
                      }));
                    }
                  })]
                }))]
              }));
            }), isCollapsible && _jsxs(View, Object.assign({
              style: successPageStyles.collapsedSection
            }, {
              children: [_jsx(Collapsible, Object.assign({
                ref: collapsibleRef,
                showIcon: false,
                childPaddingToken: 'SPACING_0',
                childNoVerticalPadding: true,
                titleNoHorizontalPadding: true,
                titleNoVerticalPadding: true,
                titlePaddingToken: 'SPACING_0'
              }, {
                children: _jsx(View, Object.assign({
                  style: successPageStyles.collapsedArray
                }, {
                  children: collapsedArray.map(info => {
                    return _jsxs(View, Object.assign({
                      style: successPageStyles.infoSectionDetail
                    }, {
                      children: [_jsx(Typography, {
                        text: info.infoKey,
                        type: isLargeScreen ? 'body-single-line-sm' : 'body-single-line-xs',
                        theme: theme,
                        style: successPageStyles.infoSectionKey
                      }), _jsxs(View, Object.assign({
                        style: successPageStyles.infoLink
                      }, {
                        children: [_jsx(Typography, {
                          text: info.infoValue,
                          type: isLargeScreen ? 'body-para-md-bold' : 'body-para-sm-bold',
                          theme: theme,
                          style: successPageStyles.infoSectionValue
                        }), !!info.hyperLink && _jsx(Button, {
                          buttonType: "tertiary",
                          size: 'md',
                          title: info.hyperLink.title,
                          onPress: () => {
                            (info === null || info === void 0 ? void 0 : info.hyperLink.onPressHyperLink) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                              id
                            }, info.hyperLink.onPressHyperLink), {
                              info
                            }));
                          }
                        })]
                      }))]
                    }));
                  })
                }))
              })), _jsx(View, Object.assign({
                style: successPageStyles.collapsedCta
              }, {
                children: _jsx(Button, {
                  size: isLargeScreen ? 'lg' : 'md',
                  iconName: isCollapsibleOpen ? expandedCtaIcon : collapsedCtaIcon,
                  iconPosition: "right",
                  buttonType: "tertiary",
                  version: "fixed-padding",
                  title: isCollapsibleOpen ? expandedCtaText : collapsedCtaText,
                  onPress: onTogglePress
                })
              }))]
            }))]
          })), _jsx(View, {
            children: _jsx(Divider, {
              color: LILAC_400,
              height: 1
            })
          }), !!buttonProps && _jsx(View, Object.assign({
            style: successPageStyles.buttonSection
          }, getTestId('buttonProps', 'acknowledgementsuccesspage'), {
            children: buttonProps.map(button => {
              return _jsx(Button, {
                size: isLargeScreen ? 'md' : 'sm',
                title: button === null || button === void 0 ? void 0 : button.title,
                buttonType: button === null || button === void 0 ? void 0 : button.type,
                style: successPageStyles.actionCta,
                version: isLargeScreen ? 'fixed-padding' : 'variable-width',
                onPress: () => {
                  (button === null || button === void 0 ? void 0 : button.actionCtaPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                    id
                  }, button === null || button === void 0 ? void 0 : button.actionCtaPressMetaData), {
                    button
                  }));
                }
              });
            })
          }))]
        }), isLargeScreen && _jsx(View, Object.assign({}, getTestId('infoNavigationArray', 'acknowledgementsuccesspage'), {
          children: !!infoNavigationArray.length && infoNavigationArray.map(info => {
            return _jsx(View, Object.assign({
              style: successPageStyles.navigateSection
            }, {
              children: _jsx(Typography, {
                multiText: info.multiText,
                type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
                theme: theme
              })
            }));
          })
        }))]
      }))]
    })), !isLargeScreen && _jsx(View, Object.assign({
      style: successPageStyles.paddingTop
    }, getTestId('infonavigationarrayformobile', 'acknowledgementpagebuttonprops'), {
      children: !!infoNavigationArray.length && infoNavigationArray.map(info => {
        return _jsx(View, Object.assign({
          style: successPageStyles.navigateSection
        }, {
          children: _jsx(Typography, {
            multiText: info.multiText,
            type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
            theme: theme
          })
        }));
      })
    }))]
  });
};